<script>
    import FaSpinner from 'svelte-icons/fa/FaSpinner.svelte'

    export let action = async () => {
    }
    export let cl
    let isActive = true

    async function onClick() {
        isActive = false
        await action()
        isActive = true
    }
</script>
<style>
    .item:disabled {
        color: var(--near-ink);
    }

    .spinner {
        animation: rotation 1s infinite ease-in-out;
    }

    @keyframes rotation {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(359deg);
        }
    }
</style>
<button class='primary {cl}' on:click={onClick} disabled={!isActive}>

    {#if !isActive}
        <span class="spinner icon mr1"><FaSpinner/></span> Processing...
    {:else}
        <slot class='item'>Button</slot>
    {/if}

</button>